import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { WithdrawService } from '../services/WithdrawService'
import { WithdrawParams } from '../services/WithdrawService/withdraw'

export const useWithdraws = () => {
  const [params, setParams] = useState<WithdrawParams>({})
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['withdraws', params],
    queryFn: async () => WithdrawService.withdraw(params),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
  }
}
